import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { dungPhien } from '../auth/PhienDangNhap';
import { goiApi } from '../lib/api';

/**
 * Dải cảnh báo KẾT NỐI TRÙNG — hiện ngay sau khi đăng nhập, cho mọi tài khoản
 * có quyền quản lý kết nối.
 *
 * BOSS yêu cầu 28/09/2026: API key/gian hàng trùng thì "có thông báo và tự kích
 * hoạt khi acc khác nhau đăng nhập", vì trùng là số liệu bị cộng dồn hoặc ghi
 * đè. Trùng MỚI đã bị chặn ngay lúc lưu; dải này chỉ để lộ ra trùng CŨ có từ
 * trước khi có cơ chế chặn, tới khi có người xoá bớt một bên.
 *
 * Chỉ hiện TÊN kết nối, không bao giờ hiện credential.
 */
interface KetNoiTrung {
  trung: { nenTang: string; truong: string; cacNhom: string[] }[];
}

export function DaiKetNoiTrung() {
  const { co } = dungPhien();
  const dieuHuong = useNavigate();
  const duocXem = co('adm', 'connect');

  const { data } = useQuery({
    queryKey: ['connect-canh-bao-trung'],
    queryFn: () => goiApi<KetNoiTrung>('/connect/canh-bao-trung'),
    enabled: duocXem,
    // Không cần tươi từng giây — trùng cũ chỉ đổi khi có người sửa kết nối,
    // mà lúc đó màn Kết nối đã tự làm mới truy vấn này.
    staleTime: 5 * 60_000,
  });

  if (!duocXem || !data || data.trung.length === 0) return null;

  return (
    <div
      role="alert"
      style={{
        background: 'var(--alads-do-nen)',
        color: 'var(--alads-do-chu)',
        border: '1px solid var(--alads-do-vien)',
        borderRadius: 10,
        padding: '10px 14px',
        margin: '0 0 14px',
        fontSize: 13,
        lineHeight: 1.55,
      }}
    >
      <strong>Có kết nối đang TRÙNG nhau — số liệu có thể bị cộng dồn hoặc ghi đè.</strong>
      <ul style={{ margin: '6px 0 6px 18px', padding: 0 }}>
        {data.trung.map((t) => (
          <li key={`${t.nenTang}-${t.truong}-${t.cacNhom.join('|')}`}>
            {t.nenTang}: {t.cacNhom.map((n) => `"${n}"`).join(', ')} cùng {t.truong}
          </li>
        ))}
      </ul>
      Việc đồng bộ đang tự bỏ qua bên trùng để không cộng dồn, nhưng cần xoá bớt một bên cho dứt điểm.{' '}
      <button
        type="button"
        onClick={() => dieuHuong('/ket-noi')}
        style={{
          font: 'inherit',
          fontWeight: 600,
          background: 'none',
          border: 'none',
          padding: 0,
          color: 'inherit',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Mở Kết nối nền tảng
      </button>
    </div>
  );
}
